
import { PageLayout } from "@/components/layout/PageLayout";
import { HeroSection } from "@/components/specializations/policyprocedures/HeroSection";
import { ServiceCards } from "@/components/specializations/policyprocedures/ServiceCards";
import { ProcessSteps } from "@/components/specializations/policyprocedures/ProcessSteps";
import { ValueMetricsSection } from "@/components/specializations/policyprocedures/ValueMetricsSection";
import { CtaSection } from "@/components/specializations/policyprocedures/CtaSection";

const PolicyProceduresDevelopment = () => {
  return (
    <PageLayout
      title="Cybersecurity Policy & Procedures Development"
      description="Professional development of custom cybersecurity policies and procedures aligned with your business goals and compliance requirements."
      keywords={[
        "cybersecurity policies", 
        "security procedures", 
        "policy development", 
        "compliance documentation", 
        "security governance"
      ]}
      canonicalUrl="/cybersecurity/policy-and-procedures-development/"
      schema={{
        type: "service",
        data: {
          name: "Cybersecurity Policy & Procedures Development",
          description: "Professional development of custom cybersecurity policies and procedures aligned with your business goals and compliance requirements.",
          provider: {
            name: "edgefi",
            sameAs: "https://edgefi.com"
          }
        }
      }}
    >
      <HeroSection />
      <ServiceCards />
      <ProcessSteps />
      <ValueMetricsSection />
      <CtaSection />
    </PageLayout>
  );
};

export default PolicyProceduresDevelopment;
